export const getPriceWithTax = (price, shippingTax) => {
  return (
    price.taxIncludedAmount ||
    price.taxFreeAmount * (price.taxRate !== 0 ? shippingTax || price.taxRate / 100 + 1 : 1)
  )
}
